import type { AxiosResponse } from 'axios';

import api from '@/utils/axiosInterceptor';
import type { ApiResponse } from '@/utils/deepmerge';

import type {
  IInvoiceSaleFullCanEdit,
  IRequestTransfer,
} from './saleToIncome.interface';

export async function PostOneRequestTransfer(requesetData: IRequestTransfer) {
  const response: AxiosResponse<{
    healthyRequestID: string;
  }> = await api.post(
    `/purchases-requests/new-request-convert-sale`,
    requesetData,
  );

  return response?.data;
}

export async function GetOneSaleInvoiceForRequest({ id }: { id: number }) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response: AxiosResponse<ApiResponse<IInvoiceSaleFullCanEdit>> =
      await api.get(`/purchases-requests/get_sale_invoice/${id}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
}
